// Port of android ComposePreviewPresentation.kt (the Mac's `isPreviewingCompose` follows the same
// rules, MacComposerControls.swift): the composer's rendered Markdown preview is meaningful only
// while there is text to render — keeping that invariant here stops the UI being stranded on an
// empty rendered surface after sending or clearing a draft.

export function isAvailable(text: string): boolean {
  return text.trim() !== '';
}

export function toggle(isPreviewing: boolean, text: string): boolean {
  return isAvailable(text) ? !isPreviewing : false;
}

export function afterTextChange(isPreviewing: boolean, text: string): boolean {
  return isPreviewing && isAvailable(text);
}

export const ComposePreviewPresentation = { isAvailable, toggle, afterTextChange } as const;
